import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import animated from 'animate.css'
import 'lib-flexible'
// import VueAMap from 'vue-amap';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// 全局挂载
Vue.use(VueAwesomeSwiper)
Vue.use(animated)
Vue.config.productionTip = false
Vue.use(ElementUI);
// Vue.use(VueAMap);

// VueAMap.initAMapApiLoader({
//   key:"41733e62bbaff14529826dcba30ebc41",
//   plugin:['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],   //插件
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
